import { createFileRoute } from "@tanstack/react-router";
import { RaidDetails } from "@/raids/RaidDetails.tsx";

export const Route = createFileRoute("/raids_/$raidId/")({
  component: () => <RaidDetails />,
});
